var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "col-lg-8 col-md-8 col-12 mt-4 mt-sm-0 pt-2 pt-sm-0"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm.message == 'saved' ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "alert alert-success"
  }, [_vm._v(_vm._s(_vm.$t("trust.movprop-success")))])]) : _vm._e(), _c('div', {
    staticClass: "col-lg-12 col-12 mb-4 pb-2"
  }, [_c('div', {
    staticClass: "card bg-light job-box rounded shadow border-0 overflow-hidden"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('h5', {
    staticClass: "text-center mb-0 mt-4"
  }, [_vm._v(" Maklumat Harta Amanah "), _c('img', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy"
    }],
    staticClass: "mb-1",
    attrs: {
      "content": "Senarai harta-harta yang akan diagihkan",
      "height": "20",
      "src": "/images/icon/info-button.png"
    }
  })]), _c('ul', {
    staticClass: "nav nav-tabs mt-4"
  }, [_vm.userRole != 'Agent' ? _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    class: _vm.routeName == 'trust-inheritance.property.immoveable' ? 'active' : '',
    attrs: {
      "to": {
        name: 'trust-inheritance.property.immoveable',
        query: {
          hibah_id: _vm.hibahId
        }
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("immov-prop")) + " ")])], 1) : _vm._e(), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    class: _vm.routeName == 'trust-inheritance.property.moveable' ? 'active' : '',
    attrs: {
      "to": {
        name: 'trust-inheritance.property.moveable',
        query: {
          hibah_id: _vm.hibahId
        }
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("mov-prop")) + " ")])], 1), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    class: _vm.routeName == 'trust-inheritance.property.transaction' ? 'active' : '',
    attrs: {
      "to": {
        name: 'trust-inheritance.property.transaction',
        query: {
          hibah_id: _vm.hibahId
        }
      }
    }
  }, [_vm._v(" Transaksi ")])], 1)]), _c('router-view')], 1)]), _c('div', {
    staticClass: "row mt-4"
  }, [_c('div', {
    staticClass: "col-lg-12 text-right"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "d-flex justify-content-between"
  }), _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.finish
    }
  }, [_vm._v(" Simpan & Hantar "), _vm.submit ? _c('span', {
    staticClass: "spinner-border spinner-border-sm"
  }) : _vm._e()])])])])])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }